/** Transport encryption mode (port of C# `EncryptionMode`). */
export enum EncryptionMode {
  None = 0,
  EncryptWithSessionKey = 1,
  EncryptWithSessionKeyAndAddress = 2,
}
